import { Injectable } from '@angular/core';
import { ProcessParticipationAppraisee } from '../../models/process-models/process-participation-appraisee.model';

@Injectable()
export class AppraiseeProvider {
    getAppraiseeName(appraisee: ProcessParticipationAppraisee) {
        return appraisee ? appraisee.name : '';
    }
}